export const unStructuredDataSources = [
  {
    title: 'OneView',
    content:
      'OneView is designed to manage and store all key company documents, including Governance, Function Regulations, BU Instructions, and Guidelines. It ensures transparency and compliance with certification and audit requirements.​',
    sourceSystem: null,
    prompts: ['I need documentation about quality policy​', 'Where can I find the Project management instructions?​'],
    datasourcelink: 'https://xecm.hitachienergy.com/otcs/llisapi.dll/open/oneview'
  },
  {
    title: 'Publisher​',
    content:
      'System for documents that allows users to publish approved documents for external access. It prevents duplication by using OneView links and requires users to be part of a publishing group with appropriate access rights.​',
    sourceSystem: null,
    prompts: [
      'Can you give me an information about transformers in Hitachi Energy?​',
      'I need technical details about GAS RELAYS​'
    ],
    datasourcelink: 'https://publisher.hitachienergy.com'
  },
  {
    title: 'ProMIS User Guide',
    content:
      'The ProMIS User Guide is a comprehensive manual designed to help users navigate and utilize the ProMIS application effectively​',
    sourceSystem: null,
    prompts: [
      'How can I upload a contract into ProMIS​',
      'What should I include in a ProMis period',
      'Can you provide the overview of Project Review report?'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/Global_FI_Risk-Management/ProMISUserGuide'
  },
  {
    title: 'TBMS SharePoint​',
    content:
      'TBMS SharePoint stores all tender documents, integrating with Salesforce for reporting and TBMS for cost collection, risks, pricing, and tender approval.​',
    sourceSystem: null,
    prompts: ['How can I create and approve a Full Cost Model in TBMS?', 'How to update a Small Tender?'],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/TBMS-Support'
  },
  {
    title: 'Epic SharePoint​',
    content:
      'EPIC SharePoint is a platform for managing project documentation, training materials, and operational guides. It supports project management processes such as contract management, risk review, and change management.​ ​',
    sourceSystem: null,
    prompts: [
      'How can I use the Project Health Status report to monitor the overall health of my projects?',
      'How to update my subscription and transfer data from PowerPoint into PowerBI?',
      'What features in EPIC help predict project execution more reliably?'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/teams/PGGIOperationsManagement/Shared%20Documents/EPIC'
  },
  {
    title: 'Mission Control Center​​',
    content:
      'The Mission Control Center enables real-time management and operation of the grid, ensuring safety, reliability, and efficiency through advanced digital technologies and integration with other enterprise IT systems.​​',
    sourceSystem: null,
    prompts: [
      'Which country have the most projects with an amber HSE status',
      'Needs all projects from Poland that are amber',
      'Needs all projects, which project cash flow is amber'
    ],
    datasourcelink:
      'https://app.powerbi.com/groups/804775e6-b44a-4cdb-a092-8c364ab07a17/reports/d5ce8ccd-da15-47aa-8efc-6badb6e46bd8/ReportSection43714478fa69fb685756?experience=power-bi'
  },
  {
    title: 'Relex End Users Manuals​​​',
    content:
      'The Relex End Users Manuals provide comprehensive guidance on navigating and utilizing the Relex platform, including data entry, improvement projects, KPI dashboards, and reporting tools.​​​',
    sourceSystem: null,
    prompts: [
      'How do I correctly enter monthly savings in the Relex application?',
      "What should I do if I can't proceed in the authorization loop in Relex?",
      'How to connect to Relex OLAP Cube?'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/RelexService/User Manuals'
  },
  {
    title: 'CCRP End User Manuals​​​',
    content:
      'The CCRP End Users Manuals provide detailed instructions on the Customer Care Response Process, including issue capture, assignment, resolution, and verification to ensure effective and sustainable complaint management.​​',
    sourceSystem: null,
    prompts: [
      'What is the largest file size I can attach to a CCRP?',
      'What does the single letter following the country code mean?',
      'How to get access to CCRP data in Power BI desktop?'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/QCIO/ccrp'
  },
  {
    title: 'Internal Acronyms list​​​​',
    content:
      'The internal acronyms list at Hitachi Energy provides detailed descriptions and standard abbreviations for various terms and concepts used within the organization.​​​',
    sourceSystem: null,
    prompts: [
      'What do SNOW and TBMS stand for?',
      'What does AAD stand for?',
      'List all acronyms in Hitachi Energy starting from letter H.'
    ],
    datasourcelink:
      'https://inside.hitachienergy.com/ph/en/what-you-need-for-your-work/communications/internal-communications/internal-acronyms#tab-tabs-4d13251b09-item-cd8dbcc333'
  },
  {
    title: 'Communication Toolkit​​​​​',
    content:
      'The Communication Toolkit at Hitachi Energy helps create and implement communication strategies, including setting up channels, feedback loops, and key messages for effective communication.​​​​',
    sourceSystem: null,
    prompts: [
      'How to communicate to achieve better business results?',
      'What are Essential building blocks in communication?',
      'What is my Strategic alignment and line of sight?'
    ],
    datasourcelink:
      'https://hitachipowergrids.sharepoint.com/:b:/r/sites/PM_Domain/Shared Documents/Applications Run/Akira/Data Sources/Communications Toolkit/'
  },
  {
    title: 'GPQS HUB NAM',
    content:
      'Reviewing Lessons Learned is essential for preventing repeat mistakes, improving efficiency, and enhancing decision-making. By analyzing past experiences, organizations can reduce risks, optimize processes, and deliver higher quality and reliability to customers. To strengthen this process, the implementation of the Akira system provides a centralized platform for reviewing, and tracking Lessons Learned. Akira enables structured analysis and real-time collaboration among stakeholders.',
    prompts: [
      'Please provide me 5 Lessons Learned for Statcom projects related to Engineering',
      'Please provide the Lessons Learned for the tendering process, including: A clear description of the problem and actions that were implemented to address it.',
      'Please provide the Lessons Learned from ATC Mount Pleasant Project.',
      'Please provide the Lessons Learned for civil construction process for GPQS HUB NAM.'
    ],
    datasourcelink:
      'https://hitachipowergrids.sharepoint.com/sites/PGGINAMResourcePlanning/Lists/Lessons%20learned%20and%20Best%20Practices/AllItems.aspx'
  },
  {
    title: 'Project Workflow Hub (PWH) End User Manuals',
    content:
      'The Project Workflow Hub is a digital platform developed as part of the Operations Improvement Plan (OIP) and the Scale to Potential (S2P) initiative. It aims to automate and digitalize the workflow management for operations processes, specifically focusing on project execution. The platform supports the entire project execution timeline through a step-by-step approach, enhancing efficiency and operational excellence.​​​​​',
    sourceSystem: null,
    prompts: [
      'How can I perform project execution stage gates?',
      'How to get access to the project within project workflow hub?',
      'How to see my project in project workflow hub?',
      'How to get signoff for project stage gates in Project Workflow Hub?'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/ProjectWorkFlowHub'
  },
  {
    title: 'Job Descriptions',
    content:
      'The Global Job Structure at Hitachi Energy provides a standardized framework for organizing and describing jobs across the organization, from entry-level to senior management. Here, we have included around 237 documents about job descriptions. Job profiles are evaluated within the context of the organization they serve, ensuring consistency and fairness in job matching and compensation.​​​​​',
    sourceSystem: null,
    prompts: [
      'What are the tasks of a PM?',
      'What is included in the job description of an engineer?',
      'How to progress your career from the position of Associate Manager to Project Manager?'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/HCG'
  },
  {
    title: 'PGGI SCM - Lessons Learnt',
    content:
      'The new data sets of SCM Lessons Learnt, Success Stories, and Best Practices at Hitachi Energy focus on capturing and sharing valuable insights to enhance supply chain management (SCM) processes. Lessons Learnt involve documenting and utilizing past experiences to avoid repeating mistakes. Success Stories highlight successful initiatives and their positive outcomes. Best Practices encompass proven methodologies and strategies to improve performance in the business process.​',
    sourceSystem: null,
    prompts: [
      'Is there any success story for optimizing total supply chain cost for control & protection systems?',
      'Are there any Best Practices that we can use to reduce the budget for steel structural projects?'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/PGSCM/PGGI'
  },
  {
    title: 'GPQS Project Execution Lessons Learned',
    content:
      'The GPQS (Grid & Power Quality Solutions) Lessons Learned is designed to capture, process, record, and control lessons learned from various projects and activities within Hitachi Energy. This program is part of the Continuous Improvement strategy and the Quality Improvement Plan.​',
    sourceSystem: null,
    prompts: [
      'What were the key challenges faced during the project execution phase?',
      'How effective were the measures taken to ensure data security?',
      'What lessons were learned about managing project-related data?'
    ],
    datasourcelink:
      'https://app.powerbi.com/groups/me/reports/4a864acb-cd32-4ab7-9cc6-99d1610f45dd/df31a13970e13bf2e1ab?ctid=7831e6d9-dc6c-4cd1-9ec6-1dc2b4133195&experience=power-bi'
  },
  {
    title: 'NCR',
    content:
      "NCR Tool is designed to record and manage internal process failures for GPQSS & Power Consulting. The purpose of recording NCR's is to 'Make Quality Visible' by recording the issue, required resolution, root cause and cost of the issue to enable Hitachi Energy to focus any continuous improvement activities.​",
    sourceSystem: null,
    prompts: ['Where can I record a non-conformity in GPQSS?', 'What is the NCR Origin?', 'What is a defect category?'],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/NCR/GPQS/SitePages/Home.aspx?OR=Teams-HL&CT=1723021300932&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNDA2MjcyNDgxNyIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ=='
  },
  {
    title: 'Data Privacy & Protection',
    content:
      'The Global Privacy Sharepoint is a resource for privacy related information. It holds guidance, contact information for privacy, trainings and quick-links to other privacy tools and resources in Hitachi Energy.',
    sourceSystem: null,
    prompts: [
      'What should be included in a privacy notice?',
      'What are some best practices for handling personal data?',
      'What constitutes a legitimate interest for processing personal data?'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/GlobalLIPrivacy'
  },
  {
    title: 'Integrity',
    content:
      'The Integrity Portal as part of the Legal & Integrity Intranet Page is an internal resource for integrity related information. It contains information about the Global Integrity Program and Team, Hitachi Group Code of Ethics and Business Conduct, Integrity Policies and Procedures, Training, Reporting information and channels, and Q&As.',
    sourceSystem: null,
    prompts: [
      'How can I report a misconduct?',
      'What is our policy on conflict of interest?',
      'What are the due diligence requirements for third parties?'
    ],
    datasourcelink: 'https://www.hitachienergy.com/about-us/our-people-and-culture/integrity'
  },
  {
    title: 'Global Legal & Integrity Regulatory',
    content:
      'The Antitrust and Regulatory data source enables access to antitrust guidance on specific topics, updates on regulatory trends and compliance requirements, as well as corporate, finance and M&A information.',
    sourceSystem: null,
    prompts: [
      'What are the antitrust risks associated with participating in trade associations and the best practices to mitigate these risks?',
      'What is the status of PFAS discussions in the EU?',
      'Which negotiation tips do I need to know for a new transaction?'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/GlobalLIRegulatory/SitePages/CollabHome.aspx'
  },
  {
    title: 'Cybersecurity Governance Risk and Compliance',
    content:
      'The Cybersecurity Governance, Risk, and Compliance (GRC) team protects information assets by providing comprehensive services, including cybersecurity risk assessments, exceptions and issues assessments, policies and documents management and ongoing consultancy while ensuring compliance, fostering a culture of security awareness and digital resilience.',
    sourceSystem: null,
    prompts: [
      'Where can I request Cybersecurity Governance, Risk & Compliance service?',
      'What is the Cybersecurity Governance assessment for?',
      'How to attest to a control in ServiceNow?'
    ],
    datasourcelink:
      'https://hitachipowergrids.sharepoint.com/teams/HitachiEnergyCybersecurityTeam/Shared%20Documents/Forms/AllItems.aspx?e=5:9e4ba51081d349ae8a9ab9f28b5b0252&sharingv2=true&fromShare=true&at=9&CT=1730987720506&OR=OWA-NT-Mail&CID=01648e3a-8bd5-092f-1fd0-372fbd0b819a&FolderCTID=0x012000E18EF56A2462514498B69C142FDE3500&id=%2fteams%2fHitachiEnergyCybersecurityTeam%2fShared%20Documents%2fGovernance%2c%20Risk%20and%20Compliance%2fWorkspace%2f1.%20Governance%2fAkira'
  },
  {
    title: 'Intellectual property',
    content:
      'The Intellectual Property data source provides information regarding the IP team members and team structure, guidance on specific IP topics, and information on submitting invention disclosures.',
    sourceSystem: null,
    prompts: [
      'Who can I speak to about an IP query related to Grid Integration?',
      'Who do I speak to if I want to register a trade mark?',
      'How do I submit an invention?',
      'How long will my invention take to be reviewed?'
    ],
    datasourcelink:
      'https://inside.hitachienergy.com/what-you-need-for-your-work/legal-and-integrity/intellectual-property'
  },
  // {
  //   title: '22. Supply Chain Management – Performance and Analytics (P&A)',
  //   content: 'We provide analytics and reporting for Supply Chain Management and Trade, Transport and Logistics functions on finance linked metrics, helping to quantify their impact on the business.This helps drive data-based and impact-oriented decision making.We manage end to end performance management process – defining metrics and KPIs, target process, reporting pro-cess, managing SCMIS and providing need-based analytics.We aim to constantly improve reporting quality and focus on standardization and automation of the performance man-agement process.',
  //   sourceSystem : null,
  //   prompts: ['How to get access to SCMIS, Savings Entry Tool (SET) and Target Setting tool (TST)?', 'What is the monthly Performance reporting schedule followed by SCM P&A?', 'What are the Direct and Indirect MDF codes with description?', 'Definition of SCM KPI – Cost Reduction?'],
  //   datasourcelink:'https://hitachipowergrids.sharepoint.com/sites/PGSCM/P&A'
  // },
  {
    title: 'HVDC Academy',
    content:
      'HVDC Academy builds the people who build our systems, empowering them with the competencies to reach their full potential.',
    sourceSystem: null,
    prompts: [
      'Can you send me the link to HVDC Academy portal?',
      'Can i have HVDC Internal training link?',
      'Give me HVDC TK Trainings link?'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/HVDCInternalTrainingPortal'
  },
  {
    title: 'SAP Center of Expertise',
    content:
      'Includes information on how to access the system, request roles, how to set approval delegations, how to login into the system, and some additional best practices to use the system.',
    sourceSystem: 'SAP CoE supporting documents library',
    prompts: ['How to request SAP access?', 'How to request a new SAP role?', 'How is COTD calculated?'],
    datasourcelink:
      'https://hitachipowergrids.sharepoint.com/sites/SAP-CoE/Training%20recordings%20and%20videos/Forms/AllItems.aspx?csf=1&web=1&e=qTIdHF&CID=3eaa2779%2D262c%2D441c%2Da18b%2De4d92baa3305&FolderCTID=0x012000089F59108CBC114FB6A251688EDB719B&id=%2Fsites%2FSAP%2DCoE%2FTraining%20recordings%20and%20videos%2FAkira'
  },
  {
    title: 'Open Source Security',
    content:
      'Open Source Security Team ensures HE products are free of legal, security, and operational risk. The team oversees global open source process by raising awareness, defining regulations and policies, analyzing scans, and helping product teams in their mitigation efforts. OSS Portal is the main source of all information required to get release clearance.',
    sourceSystem: null,
    prompts: [
      'Is open source process mandatory for every HE product?',
      'How to check if the OSS license I plan to use will be approved?',
      'Can I contribute to OSS project?'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/PG-SDIP/Portal/SitePages/OSS.aspx'
  },
  {
    title: 'People Portal',
    content:
      'The People Portal at Hitachi Energy is a centralized platform designed to support employees and People managers with HR processes, tools, and resources, focusing on areas such as employee life cycle, talent and learning, salary and pay. It serves as a hub for accessing all HR-related information.',
    sourceSystem: null,
    prompts: [
      'How can I access the HR tools and applications through the People Portal?',
      'What are the HR processes, policies, tools and regulations in Hitachi Energy?',
      'What resources are available for talent and learning on the People Portal?'
    ],
    datasourcelink: 'https://inside.hitachienergy.com/what-you-need-for-your-work/people-portal'
  },
  {
    title: 'Branding',
    content:
      "The brand design refresh includes a new logo, updated typography, and a refined color palette. These changes are intended to harmonize the brand's global presence and ensure consistency across all regions.",
    sourceSystem: null,
    prompts: [
      'What are the key elements of the new Hitachi Energy brand design, and how do they differ from the previous branding?',
      'How can employees access and utilize the updated Microsoft Office templates and other brand assets?',
      'Whom should I contact for any Branding related concerns?'
    ],
    datasourcelink:
      'https://inside.hitachienergy.com/what-you-need-for-your-work/communications/branding/brand-design-refresh-one-hitachi'
  },
  {
    title: 'Local People Portal',
    content:
      'The local People Portal at Hitachi Energy provides country-specific resources for employees and people managers, focusing on HR processes and tools. It covers areas such as Employee Life Cycle, Talent and Learning, Compensation and Benefits and other. The local People Portal is published for the following countries and regions: South Africa, Benelux, Brazil, Bulgaria, Czech Republic, Denmark, Finland, Hungary, Italy, Middle East, New Zealand, Poland, Singapore, Slovakia, Sweden, Taiwan, UK and Ireland, United States, and Vietnam.',
    prompts: [
      'What are the life cycles followed by the employees in UK & Ireland?',
      'Jakie cykle życia są przestrzegane przez pracowników w Polsce?',
      'What resources are available for talent and learning on Singapore People Portal?'
    ],
    datasourcelink: 'https://inside.hitachienergy.com/pl/pl/what-you-need-for-your-work/people-portal'
  },
  {
    title: 'SAP Master Data Governance',
    content:
      'SAP Master Data Governance (SAP MDG) is a tool that enables enterprises to govern master data centrally, improve data quality, maintain consistency across systems, and support efficient business operations.',
    prompts: [
      'How to create a customer?',
      'How to create a supplier ?',
      'How to extend a customer or supplier company code?',
      'How to block/unblock a customer or supplier?'
    ],
    datasourcelink:
      'https://hitachipowergrids.sharepoint.com/sites/MDGHitachiEnergy?OR=Teams-HL&CT=1696312616208&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiIyNy8yMzA5MDExMjI3OCIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D'
  },
  {
    title: 'Global Events Knowledge Hub',
    content:
      "The Global Events Knowledge Hub serves as the central resource for the Event Toolkit—a comprehensive collection of event-related guides, templates, checklists, blueprints, and best practices grounded in industry standards and tailored to Hitachi Energy's business operations.",
    prompts: [
      'I’m new to the Global Events Knowledge Hub. Where should I start exploring if I want to organize a successful event? Please recommend key guides, checklists, and blueprints for each phase of event planning.',
      'Show me all event management templates available in the Global Events Knowledge Hub that I can use for planning, budgeting, and promoting my upcoming event. Please include links and a brief description for each template.',
      'What are the golden rules and best practices for inviting customers to events, according to the latest guidelines in the Event Toolkit? Please reference any relevant checklists or guides.'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/eventshub/Shared Documents/Forms/AllItems.aspx'
  },
  {
    title: 'Navigating Media, Social Media, and Vendor/Supplier Engagement Guidelines',
    content:
      'Hitachi Energy’s rules of engagement for media interactions, social media usage, and vendor/supplier testimonials.',
    prompts: [
      'What steps should I take if a journalist contacts me on social media?',
      'How do I request approval for a vendor testimonial?',
      'What are the key rules for posting company-related content on my personal social media?'
    ],
    datasourcelink:
      'https://inside.hitachienergy.com/ch/en/news/internal-news/2023/09/navigating-media-social-media-and-vendor-supplier-engagement-guidelines-at-hitachi-energy'
  },
  {
    title: 'Sensitive Topics and Red Flags',
    content:
      'Guidance on identifying and managing sensitive topics in communications, including “red flag” issues that could pose reputational or legal risks.',
    prompts: [
      'Where can I find the list of sensitive topics to avoid in social media posts?',
      'What should I do if I need to communicate about a sensitive issue during a crisis?',
      'How do I escalate a potential red flag topic to the Communications team?'
    ],
    datasourcelink:
      'https://inside.hitachienergy.com/what-you-need-for-your-work/communications-and-government-relations/external-and-crisis-communications/sensitive-content'
  },
  {
    title: 'Merchadise',
    content:
      'Our merchandise guidelines ensure that all branded items reflect Hitachi Energy’s identity consistently and professionally. This page provides clear standards for logo usage, colors, and messaging, along with approved product categories, vendors, and ordering processes—helping you create merchandise that strengthens our brand and meets quality expectations.',
    prompts: [
      'How do I order branded merchandise?',
      'How do I order promo items?',
      'What logo should I use for merchandise?'
    ],
    datasourcelink: 'https://inside.hitachienergy.com/what-you-need-for-your-work/communications/branding/merchandise'
  },
  {
    title: 'Quality & Continuous Improvement',
    content:
      "Outlines the company's strategies for a robust quality management system and fostering a culture of continuous improvement through methodologies such as Lean and Six Sigma. It emphasizes the importance of a strong quality culture, leadership, and employee engagement to drive productivity and operational excellence while ensuring a superior customer experience.",
    prompts: [
      'How does the Quality Management System help ensure quality?',
      'How do we drive continuous improvement?',
      'Where can I learn more about Lean and Six Sigma?',
      'How can I grow my career in Quality & Continuous Improvement?',
      'What are the global Quality Awards?'
    ],
    datasourcelink: 'https://inside.hitachienergy.com/what-you-need-for-your-work/quality-continuous-improvement'
  },
  {
    title: 'Sustainability',
    content:
      "Outlines the company's commitment to integrating sustainability into its business strategy, focusing on environmental, social, and governance (ESG) aspects. It provides resources and guidelines for employees to support sustainable practices, emphasizing the importance of reducing carbon emissions, promoting circular economy initiatives, and enhancing stakeholder engagement.",
    prompts: [
      `How does Hitachi Energy's sustainability strategy align with the United Nations 2030 Agenda for Sustainable Development and other international conventions?`,
      `What are the three distinct strands of action in Hitachi Energy's sustainability strategy?`,
      `How does Hitachi Energy incorporate stakeholedrs to do its sustainability practices?`
    ],
    datasourcelink: 'https://inside.hitachienergy.com/what-you-need-for-your-work/sustainability'
  },
  {
    title: 'Marketing & Sales (Intranet pages)',
    content:
      'Comprehensive guidelines and resources for managing marketing and sales activities, focusing on strategies to enhance customer engagement and drive sales performance. It includes information on processes, tools, and best practices to support effective marketing campaigns and sales operations across the organization.',
    prompts: [
      'What are the key strategic marketing initiatives run by Hitachi Energy?',
      'What best practices are recommended for improving sales performance?',
      'What are the guidelines for enhancing customer engagement?'
    ],
    datasourcelink: 'https://inside.hitachienergy.com/what-you-need-for-your-work/marketing-and-sales'
  },
  {
    title: 'Eloqua landing pages',
    content:
      'Provides examples of various types of communications sent to customers connected with their participation in the events. Provide an overview of Hitachi Energy solutions dedicated to various markets: Digitalization, Data Center, Renewables, Industries, Utilities, Transportations.',
    prompts: [
      'What is the latest utilities trend?',
      'Show an example of VIP gathering invite?',
      'Show me the storyline we have for digitalization segment?'
    ],
    datasourcelink: 'https://go.hitachienergy.com/utilities-ebook'
  },
  {
    title: 'Hitachi Energy web pages',
    content:
      "The website https://www.hitachienergy.com/ provides comprehensive information on Hitachi Energy's products, services, and solutions, including digitalization and renewable energy options. It also offers insights into various markets served, sustainability initiatives, and company details such as history and career opportunities. Additionally, the site includes updates on news and events, as well as guidance on compliance and reporting channels. ",
    prompts: [
      `What is Hitachi Energy's mission?`,
      'What career opportunities are available at Hitachi Energy?',
      'How does Hitachi Energy contribute to renewable energy?'
    ],
    datasourcelink: 'https://www.hitachienergy.com/'
  },
  {
    title: 'Inside Energy',
    content:
      "Hitachi Energy's internal intranet portal providing employees with the latest company news, organizational announcements, overviews of business units, and essential tools and resources needed for day-to-day work.",
    prompts: [
      'What are the latest internal news and organizational announcements at Hitachi Energy?',
      'Where can I find information about our company values, strategy, and leadership?',
      'What internal tools and resources are available to support my daily work?',
      'How do I navigate the intranet to find HR, IT, or compliance-related resources?'
    ],
    datasourcelink: 'https://inside.hitachienergy.com'
  },
  {
    title: 'RDE eCAD',
    content: "eCAD provides innovative, secure products, data, and services tailored to the needs of our customers so that they can deliver high-quality projects in a short time to fulfill all requirements from sales until installation on site and beyond. ",
    prompts: [
      `Can you give me information about eCAD products?`,
      `Which applications are supported by eCAD and who's the application manager?`,
      'Whom shall I contact if I have any queries related to E3 or DS-E3?',
      'What are the release dates for current Pi? (exa: Pi3 2025)'
    ],
    datasourcelink: 'https://hitachipowergrids.sharepoint.com/sites/RDE_ECAD/SitePages/Home(1).aspx'
    }
]
